import React from 'react';

import { TimePicker } from '@firesoon/antd';
import DatePicker from './DatePicker';
import MonthPicker from './MonthPicker';
import QuarterPicker from './QuarterPicker';
import YearPicker from './YearPicker';
import RangePicker from './RangePicker';
import CombinePicker from './CombinePicker';
import { DatePickerDecorator, FSDatePickerProps } from './interface';

const DatePickerCopy = DatePicker as React.FC<FSDatePickerProps>;

Object.assign(DatePickerCopy, {
  TimePicker,
  MonthPicker,
  QuarterPicker,
  YearPicker,
  RangePicker,
  CombinePicker,
});

export default DatePickerCopy as DatePickerDecorator;
